
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { ConfigService } from './config.service';


@Injectable()
export class DashboardTemplateService {

	templates: any[] = [];
	allImages: any[] = []; 	// allImages is just the json configuration file contents for images

	// if a user goes directly to a custom template, we need a way to indicate this service is ready
	configurationCompleteObservable = new BehaviorSubject<any>(false);
	configurationCompleteObserver;
	configurationComplete = false;
	customDashboardProcessed = false;
	userDashboardProcessed = false;
	imagesProcessed = false;

	constructor ( private configService: ConfigService, private http: HttpClient ) {
		this.configurationCompleteObserver = this.configurationCompleteObservable.asObservable();
		this.readAllImages();
	}

	getAllImages() {
		return this.allImages;
	}

	// Remove any existing dashboards.  Good to do  when a new login has just occurred.
	clearDashboards() {
		this.templates = [];
	}

	getDashboardTemplates () {
		return this.templates;
	}

	addTemplate(newTemplate: any) {
		newTemplate.templateDetails['url'] = '/dashboardTemplate//-999?id=' + newTemplate.templateDetails.id;
		this.templates.push(newTemplate);
		// console.log(this.templates);
	}

	// delete template
	deleteTemplate(template: any) {
		let deleteIndex = -1;
		for ( let i = 0; i < this.templates.length; i++ ) {
			if ( this.templates[i].templateDetails.id === template.id ) {
				deleteIndex = i;
			}
		}
		if ( deleteIndex != -1 ) {
			this.templates.splice(deleteIndex);
		}
		// console.log(this.templates);
	}

	getDashboardTemplate(id) {
		let i = 0;
		// console.log(this.templates);

		for ( i = 0; i < this.templates.length; i++ ) {
			// console.log(this.templates[i].templateDetails.id);

			if ( this.templates[i].templateDetails.id === id ) {
				return this.templates[i].templateDetails;
			}
		}
		return null;
	}

	// If the template configurations are in a static file, get the contents of that file.
	parseDataFile(): Observable<any> {
		const fullPath = this.configService.createFullPath('customDashboards');
		console.log(fullPath);
		if ( fullPath !== '') {
			return this.http.get(fullPath);
		} else {
			return of('{}');
		}
	}

	// If the station images are in a static file, get the contents of that file.
	parseImageFile(): Observable<any> {
		const fullPath = this.configService.createFullPath('customDashboardImages');
		console.log('Reading image definition file', fullPath);
		if ( fullPath !== '') {
			return this.http.get(fullPath);
		} else {
			return of('{}');
		}
	}

	// Retrieve the definition of images associated with each station.
	readAllImages() {
		// console.log('In readAllImages');
		this.parseImageFile()
			.subscribe ( imageObject => {
				// console.log('Read image file', imageObject);
				if ( imageObject.hasOwnProperty('stationImages')) {
					// console.log('Setting allImages to ', imageObject.stationImages);
					this.allImages = imageObject.stationImages;
				}
				this.setImagesProcessedTrue();
			}, error => {
				// must set to true even though error occurred so at least templates can be shown
				this.setImagesProcessedTrue();
			}
			);
	}

	setImagesProcessedTrue() {
		this.imagesProcessed = true;
		this.configurationComplete = this.customDashboardProcessed && this.userDashboardProcessed && this.imagesProcessed;
		this.checkConfigurationComplete();
		console.log('Images are good to go');
	}

	setCustomDashboardProcessedTrue() {
		this.customDashboardProcessed = true;
		this.configurationComplete = this.customDashboardProcessed && this.userDashboardProcessed && this.imagesProcessed;
		this.checkConfigurationComplete();
		console.log('Custom dashboards are good to go');
	}

	setUserDashboardProcessedTrue() {
		this.userDashboardProcessed = true;
		this.configurationComplete = this.customDashboardProcessed && this.userDashboardProcessed && this.imagesProcessed;
		this.checkConfigurationComplete();
		console.log('User dashboards are good to go');
	}

	checkConfigurationComplete() {
		if ( this.configurationComplete == true ) {
			this.configurationCompleteObservable.next(true);
		}
	}

	getConfigurationComplete() {
		return this.configurationComplete;
	}
}
